const mpdata2023=[
  {
    Roll: "18BEC001",
    Name: "Aalap sanghvi",
    Mail: "sanghviaalap24@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Rutul Patel",
    Company: "Entyce Immersive Media Pvt. Ltd. ",
    Linkedin: "https://www.linkedin.com/in/aalap-sanghvi/",
    Project: "Development of Product in Augmented Reality",
    Description: "Working on a product from scratch in Augemnted reality ",
    Tools: "Unity ",
    Nature: "Product Developement",
  },
  {
    Roll: "18BEC018",
    Name: "Chaudhary hardikkumar dineshbhai",
    Mail: "hardikchaudhary9750@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Crest Data System pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/hardik-chaudhary-79240a183/",
    Project:
      '"Create Search Head Cluster, Indexer Cluster using Ansible/Puppet and install AWS TA & Collect all the metrics',
    Description:
      '"Create Search Head Cluster, Indexer Cluster using Ansible/Puppet and install AWS TA & Collect all the metrics - Setup Distributed Environment. - Setup Search Head Cluster. - Create a script to install AWS TA. - Setup NagiOS/Thruk and Monitor the Splunk Services. - Data Forwarding and Onboarding. - Data Searching using SPL.',
    Tools:
      'Technologies: - Infrastructure Tool: Terraform - Configuration Tool: Puppet/Ansible - Monitoring: Nagi OS/Thruk"',
    Nature: "Product Developement",
  },
  {
    Roll: "18BEC070",
    Name: "Yamankumar virendra parmar",
    Mail: "yamanvparmar@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Ruchi Gajjar",
    Company: "ISRO",
    Linkedin: "https://www.linkedin.com/in/yaman-parmar-a9ba3b193",
    Project: "Electrical subsystem design for optical Wireless communication",
    Description:
      "Deep space Laser communication by means of pulse modulation techniques. ",
    Tools: "Matlab, Verilog",
    Nature: "Research",
  },
  {
    Roll: "18BEC074",
    Name: "Patel rutvikkumar popatbhai",
    Mail: "rutvikpatelofficial07@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Ruchi Gajjar",
    Company: "EC, Nirma Uni",
    Linkedin: "https://www.linkedin.com/in/rutvik-patel-27444b168",
    Project: "Smart traffic management system",
    Description:
      "Vehical Detection,Collision Detected, Conjection Detection , Ambulance Detection, Detect animals on the road",
    Tools: "Python, Nvidia Jetson nano",
    Nature: "Product Developement",
  },
  {
    Roll: "18BEC103",
    Name: "Shrey jain",
    Mail: "shrey.jain56@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr. Yogesh Trivedi",
    Company: "Limelight IT",
    Linkedin: "http://linkedin.com/in/shrey-j-758568137",
    Project: "IOT Automation of Zero Level Industries to Industry 4.0",
    Description:
      "Helping SME and MSME to adapt Industry 4.0 Technologies efficiently and swiftly at affordable cost",
    Tools: "Arduino IDE, UART Protocols , MQTT",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC001",
    Name: "Aakarshak suresh nandwani",
    Mail: "aakarshak8@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "https://www.linkedin.com/in/aakarshak-nandwani-877424190/",
    Project:
      "Synopsys Internal Project + Implementing 128-Bit AES algorithm using Verilog ",
    Description:
      "The main aim of this project is to implement Advanced Encryption Standard (AES) Encryption using Verilog",
    Tools: "Verilog, System Verilog, UVM ",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC002",
    Name: "Aanchal tiwary",
    Mail: "tiwariaanchal0@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Intrisol",
    Linkedin: "https://www.linkedin.com/in/aanchal-tiwary-51a2b61a5",
    Project: "Moisture Meter GUI",
    Description:
      "To make a GUI for testing all the functionalities of moisture meter at the embedded side",
    Tools: "Vscode",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC003",
    Name: "Adish golechha",
    Mail: "adish.golechha@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Ruchi Gajjar",
    Company: "Central Group ",
    Linkedin: "https://www.linkedin.com/in/adish-golechha/",
    Project: "Re-platforming Data Models ",
    Description:
      "Central Group has multiple business units and the re-platforming project aims to develop a new data model to handle the data pipelines while ensuring the continuity of business intelligence. ",
    Tools: "SQL, Google Big Query, PowerBI, Tableau, Python, AWS",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC004",
    Name: "Aditya r",
    Mail: "radityak2001@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Yogesh Trivedi",
    Company: "Addverb Technologies",
    Linkedin: "https://www.linkedin.com/in/aditya-rk01",
    Project: "Backend Development",
    Description:
      "Building Application for WMS(Warehouse Management System). Includes backend and database related operations",
    Tools: "Java SpringBoot",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC005",
    Name: "Shyam aghara sureshbhai",
    Mail: "samoaghara@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "Perfect Renewtech Pvt Ltd",
    Linkedin: "www.linkedin.com/in/shyam-aghara-2b0728236",
    Project: "Solar Panel Design and Estimation  ",
    Description:
      "Design & estimation of the solar PV array at the industry with the smart devices analyze real time data.",
    Tools: "SketchUp",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC006",
    Name: "Harsh ahuja",
    Mail: "ahujaharsh20@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Sachin Gajjar",
    Company: "Deloitte, Ahmedabad",
    Linkedin: "https://www.linkedin.com/in/harsh-ahuja-b32a7a1a0",
    Project: "Internship",
    Description: "Data Analysis on sales/purchase data",
    Tools: "Excel,powerBI",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC008",
    Name: "Akshat baheti",
    Mail: "akbaheti157@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dilip Kothari",
    Company: "SAC ISRO",
    Linkedin: "https://www.linkedin.com/in/akb157/",
    Project: "GNSS Positioning",
    Description:
      "FPGA based implementation of Advanced GNSS based positioning techniques ",
    Tools: "MATLAB, C, C++",
    Nature: "Research",
  },
  {
    Roll: "19BEC009",
    Name: "Akshat muke",
    Mail: "akshatmuke3101@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "AlignTogether Solutions Pvt. Ltd.",
    Linkedin: "www.linkedin.com/in/akshat-muke",
    Project: "Product analysis, ",
    Description:
      " Optimizing compan's newly launched product using analysis and helping clients with their requirements",
    Tools: "Zoho CRM",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC010",
    Name: "Harsh anand",
    Mail: "harshanand1029@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/harsh-anand-59a738192/",
    Project: "Interfacing Sensors",
    Description:
      "In that project I interface different types of an sensors with different types of microcontroller.For different code. ",
    Tools: "Arduino IDE,Keil",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC011",
    Name: "Aum devang jasani",
    Mail: "jasaniaum@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Sachin Gajjar",
    Company: "Microally, Ahmedabad",
    Linkedin: "https://www.linkedin.com/in/aumjasani/",
    Project:
      "Electronic Speed Controller Design, Development and Manufacturing",
    Description:
      "Will work with the Embedded System Engineer team, as a Project Trainee for the designing, developing and manufacturing of an Indigenous electronic speed controller for a BLDC motor.",
    Tools: "Keil, Altium",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC012",
    Name: "Avi nawal",
    Mail: "avisnawal@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vijay Savani",
    Company: "ARM Embedded Technologies",
    Linkedin: "linkedin.com/in/avi-nawal-697290204",
    Project: "Mini-ARCUI design, Checker development",
    Description:
      "Creating an ARCUI resource database for Tormore system and Checker development, etc.",
    Tools: "Linux, Python, analyze_tgt_features tool, Python Arcui APIs",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC014",
    Name: "Ayush tiwari",
    Mail: "ayushhtiwaari.10@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Crest Data System pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/ayush-tiwari-636853190",
    Project:
      "1.) AIRBOSS  &  2.) Create Splunk Distributed Architecture with Clustering and Upgrade Splunk on it using Terraform and Puppet",
    Description:
      "-Architecture (AWS), 1x SH ,3x IDXs, 1x CM - Create a terraform script to deploy splunk architecture in AWS  - Configure puppet agents - Create a ruby script to upgrade splunk over the architecture",
    Tools: "AWS, Terraform , puppet",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC018",
    Name: "Chhichhia chaitanya rajesh",
    Mail: "chaitanya27111@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Usha Mehta",
    Company: "TCS (Digital India)",
    Linkedin: "https://www.linkedin.com/in/chaitanya-chhichhia-48033a19a/",
    Project: null,
    Description: null,
    Tools: null,
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC020",
    Name: "Harshil dabhoya",
    Mail: "harshil123dabhoya@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "Komoline aerospace Limited",
    Linkedin: "https://www.linkedin.com/in/harshil-dabhoya-a922a0211",
    Project: "Embedded Intern",
    Description:
      "Researching on end-to-end product of sensor fusion IOT Device",
    Tools: "Collab, PyCharm, Visual Studio, STM32CubeIDE, and more",
    Nature: "Research",
  },
  {
    Roll: "19BEC022",
    Name: "Debnath barun bablu",
    Mail: "barundebnath91@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Jayesh Patel",
    Company: "Media.Net Software Services Pvt. Ltd.",
    Linkedin: "https://linkedin.com/in/barundebnath",
    Project: "Infra Optimisation for Autoopt-1 team",
    Description:
      "Optimizing the legacy code of the 'AutoOpt1' team at Media Net, adding more functionalities to CI/CD pipelines, adding functionalities of vault to store secrets and ansible.",
    Tools: "Lniux, GCP, Terraform, Gitlab, Ansible, Docker, Kubernetes",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC023",
    Name: "Deep krishnani",
    Mail: "dipdip1532@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/deep-k-3371b51b5",
    Project: "-",
    Description: "Interfacing of sensors with help of arduino",
    Tools: "arduino, C ",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC025",
    Name: "Dhamecha shivangi miteshkumar",
    Mail: "dhamechashivangi0@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "Oizom Instruments Pvt. Ltd. ",
    Linkedin: "http://www.linkedin.com/in/shivangi-dhamecha-7965ba218",
    Project: "Noise Sensor based Project ( currently)",
    Description: "Research and developed the class 1 based noise sensor",
    Tools: "Arduino IDE, DSP, Embedded, MATLAB",
    Nature: "Research",
  },
  {
    Roll: "19BEC026",
    Name: "Dhruv sunil parmar",
    Mail: "dhruv.p8601@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Jayesh Patel",
    Company: "MaMo Technolabs LLP ",
    Linkedin: "linkedin.com/in/ddhruv64/",
    Project: "Web Development Internship",
    Description:
      "building websites based on the client's requirements and polishing and debugging them ",
    Tools: "HTML, CSS, AngularJS, React.js, Figma",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC028",
    Name: "Dhvanil chauhan",
    Mail: "dhvanilchauhanp@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manish Patel",
    Company: "Nervanik AI Labs Pvt. Ltd.",
    Linkedin: "http://www.linkedin.com/in/dhvanil-chauhan-45b473233",
    Project: "Linux based machine vision LTE ADAS system Improvement",
    Description: "Enhancing ADAS system",
    Tools: "Linux",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC029",
    Name: "Digvijaysinh sandeepsinh chudasama",
    Mail: "digvijaychudasama27@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "Arista Networks ",
    Linkedin: "https://www.linkedin.com/in/digvijaysinh-chudasama27/",
    Project: "Wifi System Testing",
    Description:
      "Testing and Enhancing Products and Optimizing Releases for the better performance of Arista Network's Products.",
    Tools: "Linux, Arista Networks Internal tools and technologies",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC030",
    Name: "Diwan dev nileshbhai",
    Mail: "diwandev07@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "ALTEEM INSTRUMENTS",
    Linkedin: "https://www.linkedin.com/in/dev-diwan-24d",
    Project: "Testing of the instruments",
    Description: "Testing of hardware components.",
    Tools: "Hardware based.",
    Nature: "Experimentation",
  },
  {
    Roll: "19BEC032",
    Name: "Gajjar henil hirenkumar",
    Mail: "henilgajjar08@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vijay Savani",
    Company: "Studio Carbon",
    Linkedin: "https://www.linkedin.com/in/henil-gajjar-a43a78187/",
    Project: "AI/ML Intern",
    Description:
      "Using Data from the product (developed for fitness training) to develop machine learning models to increase player performance",
    Tools: "Python, VS Code",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC033",
    Name: "Gandhi rutul miteshbhai",
    Mail: "rutulgandhi43@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "https://www.linkedin.com/in/rutul-gandhi-b309aa191/",
    Project: "Pipelined MIPS Processor in Verilog",
    Description:
      "32-bit 5-stage pipelined MIPS Processor will be designed and implemented in Verilog.",
    Tools: "Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC034",
    Name: "Gaurang maheshwari",
    Mail: "gaurang.ibd@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manish Patel",
    Company: "Bosch Global Software Technologies Private Limited (BGSW)",
    Linkedin: "https://www.linkedin.com/in/gaurang-maheshwari-6153881b8/",
    Project: "Project Trainee (AI/ML) ",
    Description: "Researching and implementing on various models",
    Tools: "Jupyter notebook, Anaconda, Vscode, python",
    Nature: "Research",
  },
  {
    Roll: "19BEC035",
    Name: "Anish gupta",
    Mail: "anishgupta2610@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Rutul Patel",
    Company: "D360",
    Linkedin: "https://www.linkedin.com/in/anish-gupta-a28a20191",
    Project: "Cloud Computing using AWS",
    Description:
      "Building & maintaining reliable & secure systems using AWS services like EC2, S3, VPC. ",
    Tools: "Amazon Web Services, Python, Go Lang, linux, Bitbucket, Okta",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC038",
    Name: "Shaily nirajbhai hirani ",
    Mail: "shailyhirani9@gmail.com ",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/shaily-hirani-598768191/",
    Project: "Android Application Development ",
    Description:
      "Development an android application that can connect to bluetooth",
    Tools: "Android Studio, Kotlin, Java, Bluetooth, Wifi, Dokka, KDoc",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC039",
    Name: "Hitarth ashishbhai patel ",
    Mail: "patelhitarth001@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Yogesh Trivedi",
    Company: "Sahjanand Laser Technology Limited ",
    Linkedin: "https://www.linkedin.com/in/hitarth-patel-2b77241a7",
    Project: "Hardware Domain ",
    Description: "Assigned work for company's hardware circuits",
    Tools: "Proteus, Arduino ",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC040",
    Name: "Indraganti vishnudatta",
    Mail: "issvishnu@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "Shaper Systems Private Limited (OPC)",
    Linkedin: "https://www.linkedin.com/in/indraganti-vishnudatta-04b0b61b1/",
    Project: "PCB Designing and PIC MCU Programming",
    Description:
      "Redesigning an existing PCB using eagle and programing the new microcontroller using MPLAB",
    Tools: "Autodesk (Eagle, Fusion 360), MPLAB IDE, MPLAB IPE",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC044",
    Name: "Parth jain",
    Mail: "jainparth0806@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "AppGambit",
    Linkedin: "https://www.linkedin.com/in/parth-jain-0804/",
    Project: "AIE Compiler",
    Description: "Developing versal ACAP",
    Tools: "Linux, GCC, Gradle, C++",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC048",
    Name: "Jugal patel",
    Mail: "jugalpatel753@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "EC, Nirma Uni",
    Linkedin: "www.linkedin.com/in/jugal-patel-7b61b61b3",
    Project: "Remed+",
    Description:
      "The task involves testing hardware systems to identify and resolve any hardware issues, including manufacturing defects, finding and fixing bugs, and documenting test results.",
    Tools:
      "Redicine MB -firmware uploading, Postman - API check, Arduino-code debugging and error check, Notion - documentation",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC049",
    Name: "Kachhy dhairya jaydeepbhai",
    Mail: "dhairyakachhy2002@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "TATA CONSULTANCY SERVICES ",
    Linkedin: "https://www.linkedin.com/in/dhairya-kachhy-709300199/",
    Project: "IOT DE Automotive",
    Description: "Project is based on AI and ML ",
    Tools: "Python, ML, AI",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC052",
    Name: "Kartikey mishra",
    Mail: "k.kartikeymishra2017@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Yogesh Trivedi",
    Company: "Addverb Technologies",
    Linkedin: "https://www.linkedin.com/in/kartikey-mishra-66817a194/",
    Project: "Warehouse Management System",
    Description:
      "Working on backend of WMS system and using Rabbit MQ to communicate with different components",
    Tools: "Java, Angular, Rabbitmq",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC055",
    Name: "Sneh kriplani",
    Mail: "snehkriplani@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Nagendra Gajjar",
    Company: "Kernel Tools",
    Linkedin: "linkedin.com/in/sneh-kriplani-b198741bb",
    Project: "Tax Invoicing Product",
    Description: "Creation of roadmaps of the login/signup and user onboarding",
    Tools: "Figma,Figjam, Whimsical",
    Nature: "Research",
  },
  {
    Roll: "19BEC056",
    Name: "Kshiteej kosambia",
    Mail: "kshiteej454@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Intrisol Technology Pvt. Ltd. ",
    Linkedin: "https://www.linkedin.com/in/kshiteej-kosambia-239b75214/",
    Project: "MTH sensor for Industrial Use",
    Description:
      "Working on Esp 32 using freeRTOS, to run different tasks concurrently  ",
    Tools: "C programming, ESP 32, freeRTOS",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC057",
    Name: "Krupa govindbhai lakhani",
    Mail: "lakhanikrupa616@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Kabra Logitech Pvt. Ltd.",
    Linkedin: "linkedin.com/in/krupa-lakhani-923298206",
    Project: "taptap.in",
    Description: "Frontend Developer",
    Tools: "React, Typescript, Redux, HTML, CSS, Javascript",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC059",
    Name: "Maharsh nirajkumar khamar",
    Mail: "kmaharsh1410@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Rutul Patel",
    Company: "MATRIX COM SEC",
    Linkedin: "https://www.linkedin.com/in/maharsh-khamar-a842271a4/",
    Project: "Studying company's products",
    Description:
      "The company works in the telecom and security domain. I have been assigned to study different types of camera they manufacture. Their technical specifications and how to configure them with their software.",
    Tools: "I will be solely using the company's software. ",
    Nature: "Experimentation",
  },
  {
    Roll: "19BEC061",
    Name: "Khushali sarvil makwana",
    Mail: "khushu1741@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "Sphere Rays Technolabs Pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/khushalimakwana/",
    Project: "AI Based Robot Design",
    Description:
      "Enhance company's UI, esearching on advancements in AI applied in ECE, Increase company asset",
    Tools: "sypder, solidworkds, arduino ide",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC062",
    Name: "Makwana purvesh",
    Mail: "purveshmakwana1234@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Yogesh Trivedi",
    Company: "EC, Nirma Uni",
    Linkedin: "zlhg3ticjys3",
    Project: "Agriculture and Crop Detecting using Machine Learning",
    Description:
      "Using Decision tree algorithm or using KNN algorithm for detecting the growth rate of crop using machine learning.",
    Tools: "python",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC064",
    Name: "Nimit shaileshbhai malani",
    Mail: "malaninimit@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "eInfochips",
    Linkedin:
      "https://www.linkedin.com/in/nimit-malani-b42888191?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BzSDY3FeGRGSt%2FXPt%2FyuJ7A%3D%3D",
    Project: "Design of UART protocol",
    Description: "Enhancing ASIC and Computer Architecture knowledge",
    Tools: "Linux, Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC065",
    Name: "Malek fiza arifbhai",
    Mail: "fizamalek711@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manisha Upadhyay",
    Company: "Bisag-N",
    Linkedin: "https://www.linkedin.com/in/fiza-malek-979a9b1aa",
    Project: "Recommendation System",
    Description:
      "Researching on Customer Purchasing Patterns and Segmenting Target Groups",
    Tools: "Python",
    Nature: "Research",
  },
  {
    Roll: "19BEC067",
    Name: "Manasi yadav",
    Mail: "manasi.yadav829@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Usha Mehta",
    Company: "Cadence Design Systems",
    Linkedin: "https://www.linkedin.com/in/manasiyadav/",
    Project: "Training",
    Description: "Training on SystemVerilog, Verilog, UVM, Linux",
    Tools: "System Verilog, Verilog, Linux, UVM",
    Nature: "Research",
  },
  {
    Roll: "19BEC070",
    Name: "Mann mehta",
    Mail: "19bec070@nirmauni.ac.in",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Intrisol Technologies Pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/mann-mehta-854513190/",
    Project: "Python Developer",
    Description: "Developing a GUI inte",
    Tools: "Python, OOPS, Software designing, Software 1Testing",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC071",
    Name: "Manvar shyamkumar ashvinbhai",
    Mail: "shyammanvar256@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Nagendra Gajjar",
    Company: "EC, Nirma Uni",
    Linkedin: "www.linkedin.com/in/shyam-manvar-019331218",
    Project:
      "RTL Design and Development of Crypto-processor and implementation on FPGA",
    Description:
      "RTL/Verilog design of crypto algorithm such as DES/AES. Simulation and  verification on Xilinx platform. Implementation of design on Xilinx FPGA ",
    Tools: "Xilinx, ISE, Vivado, Vitis",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC072",
    Name: "Mihir rana",
    Mail: "mihirrana620@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "EC, Nirma Uni",
    Linkedin: "https://www.linkedin.com/in/mihir-rana-17909b119/",
    Project: "Covid Vaccine Management System",
    Description:
      "Develop a website for covid vaccine management using Python : Making sure that people have access to proper healthcare and immunization against diseases that can be prevented by vaccines, is a huge challenge that is being faced by developing countries like ours. This highlights the importance and need of having a better, smarter system in place, to improve the situations. This application provides a system to provide information, store records and help people schedule vaccination appointments.",
    Tools: "Html, CSS, Javascript , Python, Django, Bootsrap",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC075",
    Name: "Himanshu ashvinbhai nakrani",
    Mail: "himanshunakrani0@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "State Street Corporation",
    Linkedin: "https://www.linkedin.com/in/himanshu-nakrani",
    Project: "Charles river development",
    Description: "it is an ongoing project of the company.",
    Tools: "C#, .NET, React, Python",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC076",
    Name: "Naman deo",
    Mail: "naman.deo.nd.149@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "Zeus Learning",
    Linkedin: "https://www.linkedin.com/in/namandeo/",
    Project: "Learning Express (LX)",
    Description:
      "Work on creating new pages and modifying existing pages in the Learning Express product.",
    Tools: "HTML, CSS, Javascript, Typescript, Angular",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC078",
    Name: "Nikhil gupta",
    Mail: "nikhilg2804@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Sachin Gajjar",
    Company: 'other',
    Linkedin: "www.linkedin.com/in/nikhil-gupta-0172a11a3",
    Project: "Home Automation using Tiny ML board",
    Description:
      "Designing a system that will be able to automate the home by taking commands from phone, voice or gesture. The idea is to make it into a product that can be sold in the market.",
    Tools: "TinyML board, Arduino ide, Proteus",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC080",
    Name: "Pachegaokar anushree hemanshu",
    Mail: "anupachegaokar@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dilip Kothari",
    Company: "SAC ISRO",
    Linkedin: "www.linkedin.com/in/anushreepachegaokar",
    Project: ": Implementation of Demodulator for QZSS MADOCA LEX Signal",
    Description:
      "Researching about concepts and applications of GNSS, QZSS and CSK modulation technique, Performing demodulation on sample QZSS LEX signal, Testing system model on USRP for real-time reception ",
    Tools: "MATLAB, Simulink, USRP",
    Nature: "Research",
  },
  {
    Roll: "19BEC081",
    Name: "Palak jain",
    Mail: "palakjain0927@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vijay Savani",
    Company: "iMentus Technologies",
    Linkedin: "https://www.linkedin.com/public-profile/settings",
    Project: "API development",
    Description:
      "creating a api for showing current location on map and saving the data",
    Tools: "Javascript , MongoDB , Node-js",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC082",
    Name: "Pallavi kumari",
    Mail: "pallaviisharma0609@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Usha Mehta",
    Company: "Cadence Design Systems",
    Linkedin: "https://www.linkedin.com/in/pallavi-sharma-22a7351a3",
    Project: "Training",
    Description:
      "At initial stage, the training for Verilog, System Verilog and UVM will be provided along with completion of courses on C++ and data structures and once the training is over the tasks on research projects will be assigned which will be based on Memory Model Verification.",
    Tools: "Verilog, System Verilog, UVM, Data Structures, OOPs etc.",
    Nature: "Research",
  },
  {
    Roll: "19BEC083",
    Name: "Harsh ramesh panara",
    Mail: "harshpanara22@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Greenvolt Mobility",
    Linkedin: "https://www.linkedin.com/in/harsh-panara",
    Project: "Even Os- Battery Swapping",
    Description: "Optimizing Performance of EV and Servicing of EV",
    Tools: "KiCad, Altium Designer, WEBENCH , Arduino IDE",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC084",
    Name: "Panchal aastha sanjay",
    Mail: "panchalaastha@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vijay Savani",
    Company: "ARM Embedded Technologies",
    Linkedin: "linkedin.com/in/aastha-panchal-259017235",
    Project: "Auto-Target Generator",
    Description:
      "Automatically generating partner's configuration sheet to reduce the manual tasks by the PE Team",
    Tools: "Linux, Gvim, Python",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC085",
    Name: "Pandya divyam hasitkumar",
    Mail: "divyampandya26@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "linkedin.com/in/divyam-pandya-351681223",
    Project: "Pipelined MIPS Processor in Verilog ",
    Description:
      "The design and implementation of a 32-bit 5-stage pipelined MIPS processor will be done in Verilog.",
    Tools: "Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC086",
    Name: "Tanmay kamalbhai parekh",
    Mail: "tanmayparekh20@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "Euler Motors",
    Linkedin: "linkedin.com/in/tanmay-parekh-0306",
    Project: "Design of Vehicle Control Unit ",
    Description:
      "To send the data of Vehicle Control Unit to SD Card over CAN protocol",
    Tools: "Embedded C, STM-32",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC087",
    Name: "Aakash parmar",
    Mail: "parmaraaksh2353@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Akash Mecwan",
    Company: "Monarch Innovation PVT.LTD",
    Linkedin: "https://www.linkedin.com/in/parmar-aakash-102a75192/",
    Project: "troubleshooting and testing of PCB",
    Description:
      "understanding schematic of PCB, component identification on various PCBS, troubleshooting of pcbs, circuit designing, QA of product",
    Tools: "Multimeter, DSO",
    Nature: "Research",
  },
  {
    Roll: "19BEC088",
    Name: "Parmar chinmay kiransinh",
    Mail: "parmarchinmay400@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "EC, Nirma Uni",
    Linkedin: "www.linkedin.com/in/chinmay-parmar",
    Project: "Real Time Face Detection and Recognition",
    Description:
      "To develop algorithm for preprocessing of image by drone using Jetson Nano, To Develop DNN based the Face Detection and Recognition\u00a0Algorithm ",
    Tools: "python, jetson nano",
    Nature: "Research",
  },
  {
    Roll: "19BEC089",
    Name: "Parmar raj natvarbhai",
    Mail: "rajparmar9106852538@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "ISRO",
    Linkedin: "https://www.linkedin.com/in/rajnparmar/",
    Project: "SINGLE & MULTI IMAGE SUPER RESOLUTION ",
    Description:
      "Researching on Different Algorithms and Methods on Advancement in Image Super Resolution.",
    Tools: "Python, Tensorflow, Pytorch, ML-AI.",
    Nature: "Research",
  },
  {
    Roll: "19BEC090",
    Name: "Yuvrajsinh lalsinh parmar",
    Mail: "yuvrajsinhthakor100@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Crest Data System pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/yuvrajsinh-parmar/",
    Project:
      "Create infrastructure using Terraform & Install/Configure Splunk using Configuration Management Tool- Puppet",
    Description:
      "Configuration and setup of splunk using puppet configuration management tool",
    Tools: "Puppet,AWS,CO2",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC092",
    Name: "Patel darshit pradipkumar",
    Mail: "kano02764@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manish Patel",
    Company: "Dazzle Robotics Pvt Ltd",
    Linkedin: "linkedin.com/in/patel-darshit-23a326233",
    Project: "Indoor positioning system using uwb technology",
    Description:
      "DW1000 is the world's first single-chip wireless transceiver based on Ultra-Wideband techniques. It provides a new approach to real-time location and indoor positioning systems, location-based services, wireless sensor networks. It enables to develop cost-effective RTLS solutions with precise indoor and outdoor positioning to within 10 cm. The UWB based on ESP32 and DW1000 solution, it acts like a continuously scanning radar, that precisely locks onto another device and communicates with it, thus calculating its own location, with the ESP32 WiFi/Bluetooth, it could be a solution for wireless indoor positioning.",
    Tools: "Arduino IDE",
    Nature: "Research",
  },
  {
    Roll: "19BEC093",
    Name: "Patel het sunilkumar",
    Mail: "het4902@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "E-INFOCHIPS",
    Linkedin: "https://www.linkedin.com/in/het-patel-530653200/",
    Project: "Product Engineering Services in embedded domain ",
    Description: "Enhancing Company's Devices",
    Tools: "LINUX,LINUX AWK,GITHUB,AWS,C,ARDUINO ",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC095",
    Name: "Patel jainil suhagkumar",
    Mail: "jainilpatel2211@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Super System",
    Linkedin: "https://www.linkedin.com/in/patel-jainil-3228a4241/",
    Project: "Embedded System Development",
    Description:
      "Writing Software for companies embedded products, testing and verification of circuits (PCB) ",
    Tools: "IAR Embedded Workbench, Nulink Programmer, Cadence OrCAD",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC096",
    Name: "Neel patel",
    Mail: "neelpatel.itnu@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Rutul Patel",
    Company: "EC, Nirma Uni",
    Linkedin: "www.linkedin.com/in/neel-p-178028194",
    Project:
      "Improvement in handwritten digit recognition through deep learning",
    Description:
      "Creating Deep Learning Model that works on real time handwritten digits by different people",
    Tools: "Google Colab",
    Nature: "Research",
  },
  {
    Roll: "19BEC097",
    Name: "Patel parikshit rashmikant",
    Mail: "patel1610parikshit3041@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "eInfochips",
    Linkedin: "https://www.linkedin.com/in/parikshit-patel-41b6551a4/",
    Project: "Product engineering services (Embedded Domain)",
    Description: "Enhancing Company\u2019s Devices",
    Tools: "LINUX,LINUX AWK, GIT,AWS,C,FPGA",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC098",
    Name: "Smit patel",
    Mail: "patel.smit3131@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "Oizom Instruments Pvt. Ltd. ",
    Linkedin: "https://www.linkedin.com/in/smit-patel-7688961ab/",
    Project: "ATIRA Dashboard",
    Description:
      "Need to make dashboard where all sensor info come from API and need to do server side rendering",
    Tools: "Next.js,React.js,Javascript",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC099",
    Name: "Patel sneh dushyantkumar",
    Mail: "snehpatel7801@gmail.co ",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "e-Infochios Private Limited",
    Linkedin: "https://www.linkedin.com/in/sneh-patel-0951a3208",
    Project: "Not Alltocated ",
    Description: null,
    Tools: null,
    Nature: "Research",
  },
  {
    Roll: "19BEC100",
    Name: "Patel vraj bhaveshkumar",
    Mail: "vraj14082001@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "https://www.linkedin.com/in/vrajpatel001/",
    Project: "Self Driving Vehicle Simulation and Synopsys Internal",
    Description: "Machine Learning - Object Detection/Collision Avoidance",
    Tools: "Javascript, Gazebo",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC102",
    Name: "Prince naresh bansal",
    Mail: "p4princebansal@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "Invent India",
    Linkedin: "https://www.linkedin.com/in/prince-bansal-p4",
    Project: "On2Cook",
    Description:
      "Devlopment and research on cooking device containg both microwave and induction named On2Cook",
    Tools: "Keil, StmCube IDE1, C++",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC103",
    Name: "Rai maheevatsa abhaykumar",
    Mail: "raimaheevatsa@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr. Bhuoendra Fataniya",
    Company: "EC, Nirma Uni",
    Linkedin: "www.linkedin.com/in/maheevatsa-rai",
    Project: "Real Time Face Detection and Recognition",
    Description:
      "To develop algorithm for preprocessing of image by drone using Jetson Nano. To Develop DNN based the Face Detection and Recognition\u00a0Algorithm",
    Tools: "python, Jetson nano",
    Nature: "Research",
  },
  {
    Roll: "19BEC105",
    Name: "Rathod krish amitkumar",
    Mail: "leorathod91011@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Johnson Controls Hitachi",
    Linkedin: null,
    Project:
      "Process study for Quality management system - PCB / Part approval",
    Description:
      "Part approval process of Electronics Part like diode , capacitor resistor , MOSFET , surge absorber , Full PCB assembly approval, schematic study , field return PCB troubleshooting.",
    Tools: "Jig , Fixure and Instrument used during testing and analysis",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC106",
    Name: "Pallav rathod",
    Mail: "rathodpallav456@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/pallav-rathod/",
    Project: "Image Stitching algorithm (Panaroma Image generation)",
    Description: "Prototyping of Galvano Scanner",
    Tools: "Embedded Linux, Jetson Nano, CUDA, SHELL, GCC, etc.",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC108",
    Name: "Jainil jigeshbhai raval",
    Mail: "jainilraval02@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/jainil-raval/",
    Project: "Mobile application development",
    Description:
      "mobile application development with the functionality of Bluetooth, Wi-Fi and interfaced with cloud.",
    Tools: "Android studio, VS code",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC109",
    Name: "Mann marlesh raval",
    Mail: "mannraval1@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Rachna Sharma",
    Company: "Maharshi Electronic System",
    Linkedin: "https://www.linkedin.com/in/mann-raval-95360b103/",
    Project: "Hardware Engineer ",
    Description: "Interfacing sensors and designing circuits",
    Tools: "Keil, Linux, ",
    Nature: "Research",
  },
  {
    Roll: "19BEC110",
    Name: "Rhydham",
    Mail: "rhydhamprajapati1421@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manisha Upadhyay",
    Company: "Pima controls pvt ltd.",
    Linkedin: "Rhydham Prajapati",
    Project: "Communication between PLC's (IIOT)",
    Description:
      "Developing a product for the company, where we will be building an IIOT device which will be used for communication between two PLC's",
    Tools: "STM32CubeIDE, SYCONet",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC111",
    Name: "Rinkal jain",
    Mail: "jainrinkal116@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Bhupoendra fataniya",
    Company: "Greenvolt Mobility",
    Linkedin: "linkedin.com/in/rinkal-jain-b028061b7",
    Project:
      "Optimization of Battery Swapping Network automation sytem for electric 2W-vehicles",
    Description:
      "Working the software side of the Project. Working on the Database side and the Figuring out the flow of the implementation. Along with that will work on the cloud for this system. ",
    Tools: "Python,Jupyter Notebook,SQL,LucidChart,Iot-based sensors",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC113",
    Name: "Rishita devendra chaliawala",
    Mail: "rishit.802.chaliawala@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Sachin Gajjar",
    Company: "Deloitte-India, Ahmedabad",
    Linkedin: "https://www.linkedin.com/in/rishitachaliawala",
    Project: "Data Analysis and Visualization",
    Description: "Analysing data in POWER BI ",
    Tools: "Power BI, Sql and python",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC114",
    Name: "Rythem mehta",
    Mail: "rythemmehtaa@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Rutul Patel",
    Company: "KPMG",
    Linkedin: "https://www.linkedin.com/in/rythem-mehta-7457111a7/",
    Project: "Contractual Compliance Services",
    Description:
      "Managing and optimizing software application within the organization throughout their life cycle",
    Tools:
      "SAM (Software Application Management) tools like ILMT, Record keeping in MS Excel",
    Nature: "Research",
  },
  {
    Roll: "19BEC116",
    Name: "Rajiv ajay sadriwala",
    Mail: "rajivsadriwala752001@gmail.com",
    Report: "File Not Uploaded",
    Guide: "Dr Dilip Kothari",
    Company: "Health Catalyst",
    Linkedin: "rajivsadriwala",
    Project: null,
    Description:
      "Intership is been divided into 2 part Phase 1 - Training(Jan, Feb, March), Phase 2 -  Pracital project(April, may, june), each of 90 days.     the project title will be alloted in phase 2",
    Tools:
      "not known, but preparing with c#, Excel, XML, Microsot visio and many more to go",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC117",
    Name: "Maarjani heman sanghavi",
    Mail: "maarjani23s@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "Endel Digital Solutions",
    Linkedin: "http://linkedin.com/in/maarjani-sanghavi-a73b78218",
    Project: "Automatic number plate recognition of trucks ",
    Description:
      "Using image processing and computer vision develop a system that detects and recognizes number plates on trucks ",
    Tools: "Python - Anaconda",
    Nature: "Research",
  },
  {
    Roll: "19BEC118",
    Name: "Sanghavi naitik kamlesh",
    Mail: "naitiksanghavi6@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vijay Savani",
    Company: "EC, Nirma Uni",
    Linkedin: "https://www.linkedin.com/in/naitik-sanghavi-433705205/",
    Project: "Surgical Robotics",
    Description:
      "Implementing Machine Learning, Computer Vision, and related techniques to aid and improve precision in automated surgery to be performed by robots.",
    Tools: "Tensorflow, OpenCV, Keras, Sci-kit learn",
    Nature: "Research",
  },
  {
    Roll: "19BEC119",
    Name: "Shah abhay vijeshbhai",
    Mail: "abhayshah00007@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manish Patel",
    Company: "CACTUS",
    Linkedin: "https://www.linkedin.com/in/abhay-shah07/",
    Project: "LABS PLAYGROUND TOOLS",
    Description:
      "We are working under the large umbrella of Labs playground team at cactus and it makes analytics tool for making the researchers lifecycle easy",
    Tools: "MERN Stack, ElasticSearch, Data Visualization",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC120",
    Name: "Khush jayant shah",
    Mail: "khushshahj@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Crest Data System pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/shah-khush-903b80205/",
    Project: "Create a Splunk Cluster for multiple functionality use-cases.",
    Description:
      "Live monitoring and configuration  of the platform using Splunk Enterprise tool",
    Tools: "Linux, Splunk, Cloud, Communications(TCP)",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC122",
    Name: "Shah pratham hiteshkumar",
    Mail: "shah.pratham235@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dilip Kothari",
    Company: "SAC ISRO",
    Linkedin: "www.linkedin.com/in/pratham-shah-78359121b",
    Project:
      "Deployment of Deep Learning Model on FPGA for on board Processing",
    Description:
      "Building a model of Deep Learning and optimize for Deployment on custom FPGA Board",
    Tools: "VHDL, MATLAB HDL Toolbox",
    Nature: "Research",
  },
  {
    Roll: "19BEC123",
    Name: "Shah rushi paresh",
    Mail: "rpshah274@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manisha Upadhyay",
    Company: "JEKSON VISION",
    Linkedin: "RUSHI SHAH",
    Project: "IMAGE PROCESSING",
    Description:
      "Write a code to unwarp the images of cylindrically wrapped labels to straighten them for better readability",
    Tools: "Python, C++",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC126",
    Name: "Pruthvirajsinh mahendrasinh solanki",
    Mail: "pruthvirajmsolanki@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manisha Upadhyay",
    Company: "JEKSON VISION",
    Linkedin: "https://www.linkedin.com/in/pruthvirajsinh-solanki-8381351a8/",
    Project: "Database integration with web service",
    Description: "Integration on online database system with sql.",
    Tools: "Mssql, Postman",
    Nature: "Research",
  },
  {
    Roll: "19BEC127",
    Name: "Sparsh devang palkhiwala",
    Mail: "palkhiwalasparsh2301@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "eInfochips",
    Linkedin: "https://www.linkedin.com/in/sparsh-palkhiwala-714ab6217/",
    Project: "Traffic detection for Visually Impaired People",
    Description: "Traffice detection for Visually Impaired People",
    Tools: "Machine Learning",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC128",
    Name: "Sukhadia dhwanil jatinkumar",
    Mail: "dhwanilsukhadia12@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "https://www.linkedin.com/in/dhwanil-sukhadia/",
    Project: "-",
    Description: "Analog Circuit Designing",
    Tools: "Simulation Tool of the Company.",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC129",
    Name: "Swastik handa",
    Mail: "swastikhanda167@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "Shaper System Pvt Limited(Maharshi Electronics)",
    Linkedin: "www.linkedin.com/in/swastik-handa-94581420b",
    Project: "PCB Designing and Implementation",
    Description: "Designing of 32bit microchip PCB and it's implementation ",
    Tools: "MPLAB,EAGLE",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC131",
    Name: "Taneesha chaudhary",
    Mail: "taneesha1234@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "TATA CONSULTANCY SERVICES ",
    Linkedin: "www.linkedin.com/in/taneeshachaudhary",
    Project: "EMPLOYEE MANAGEMENT SYSTEM ",
    Description:
      "Creating an employee management system where all the details of the employee are maintained.",
    Tools: "Python , pycharm , MySQL ",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC132",
    Name: "Tanisha mittal",
    Mail: "mtanisha1431@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Piyush Bhatasana",
    Company: "Arista Networks ",
    Linkedin: "https://www.linkedin.com/in/tanisha-mittal-1a5a261b4/",
    Project: "Testing ",
    Description:
      "Testing and running different test cases on new releases of the company, writing testcases for new builds",
    Tools: "Company specific tools ",
    Nature: "Experimentation",
  },
  {
    Roll: "19BEC133",
    Name: "Tejas deshpande",
    Mail: "deshpandetejas08@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "ISRO",
    Linkedin: "https://www.linkedin.com/in/tejas-deshpande-910b18217/",
    Project:
      "Creating GUI for Twyman-Green Interferometer and Michelson Interferometer",
    Description:
      "Creating GUI for Twyman-Green Interferometer and Michelson Interferometer",
    Tools: "Python, Lab-View",
    Nature: "Research",
  },
  {
    Roll: "19BEC135",
    Name: "Meet dipakbhai thakar",
    Mail: "meetthakar02@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "Infineon Technologies India Pvt Ltd",
    Linkedin: "https://www.linkedin.com/in/meet-thakar-643605220",
    Project: "-",
    Description:
      "Providing assistance to client applications, solving their doubts",
    Tools: "Aurix Development Studio, Aurix evaluation boards",
    Nature: "Experimentation",
  },
  {
    Roll: "19BEC136",
    Name: "Thakkar krishna chandrakant",
    Mail: "kthakkar.1007@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "https://www.linkedin.com/in/krishna-thakkar-3899061ab/",
    Project: "Advanced Traffic Light Controller + Synopsys Work",
    Description:
      "Extension of Normal Traffic Light Controller System by adding new features.",
    Tools: "Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC137",
    Name: "Thakkar yash ashokbhai",
    Mail: "yashthakkar12342@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "E-infochips ",
    Linkedin: "https://www.linkedin.com/in/yash-thakkar-ab97731ab",
    Project: "Design of SPI protocol",
    Description:
      "Has to design SPI protocol in verilog, also have to write 2-3 testcases",
    Tools: "Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC139",
    Name: "Shreay upadhyay",
    Mail: "shreayupadhyay23@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Sachin Gajjar",
    Company: "Powergrid Corporation of India Limited (PGCIL), Baroda",
    Linkedin: "www.linkedin.com/in/shreay-upadhyay-b65164190",
    Project: "Networking in Powergrid",
    Description: "Understanding different types of Networking in Powergrid",
    Tools: "-",
    Nature: "Research",
  },
  {
    Roll: "19BEC143",
    Name: "Vanshika gupta",
    Mail: "guptavanshika0011@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Twinkle Bhavsar",
    Company: "SYNOPSYS",
    Linkedin: "linkedin.com/in/vanshika-gupta-2b7ab7209",
    Project: "Advanced Traffic light controller using Verilog+ Synopsys work",
    Description:
      "Extension of traffic light controller by adding new features/cases and verification ",
    Tools: "Verilog",
    Nature: "Simulation",
  },
  {
    Roll: "19BEC145",
    Name: "Vora urvil amitkumar",
    Mail: "urvilvora109@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Manisha Upadhyay",
    Company: "JEKSON VISION",
    Linkedin: "https://www.linkedin.com/in/urvil-vora-3a7a39162",
    Project: "Relfection removal of image",
    Description:
      "The glares and reflection removal of images to have clear image. To resize the image and its labelling accordingly.",
    Tools: "Python, labelme, labelimg",
    Nature: "Research",
  },
  {
    Roll: "19BEC146",
    Name: "Yash gandhi",
    Mail: "gandhiyash4939@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Hardik Joshi",
    Company: "Crest Data System pvt. Ltd.",
    Linkedin: "https://www.linkedin.com/in/yash-gandhi-417b25186",
    Project:
      "POC of different monitoring tools, compare and identify the best suitable and feasible for current existing environment ",
    Description:
      "Doing POC of different software, monitor them on different parameters like CPU usage, alerts, etc then find best suitable and feasible for current environment. I have to configure different monitoring tools and then ingest data data and compare them on different monitoring parameters and find the best suitable one.",
    Tools: "Linux, Moogsoft, Nagios, Grafana, Datadog, Splunk, AWS",
    Nature: "Experimentation",
  },
  {
    Roll: "19BEC149",
    Name: "Zinzuvadiya abhishek vijaybhai ",
    Mail: "avsoni6901@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Usha Mehta",
    Company: "Cadence Design Systems",
    Linkedin: "https://www.linkedin.com/in/abhishek-zinzuvadiya/",
    Project: "Software Design",
    Description: "Enhancing Software",
    Tools: "Linux, GCC, Verilog, System Verilog, C,C++,UVM,VNC",
    Nature: "Product Developement",
  },
  {
    Roll: "19BEC505",
    Name: "Jeet manjit kapadia",
    Mail: "jeetkapadia113@gmail.com",
    Report: "File Uploaded",
    Guide: "Prof. Jayesh Patel",
    Company: "VEGG Surat",
    Linkedin: "https://www.linkedin.com/in/jeet-manjit-kapadia-23840a1b9/",
    Project: "ESP32 Development Board",
    Description:
      "Designing A custom Development board using ESP32-U4WDH. 4 Layer PCB design",
    Tools: "ALTIUM",
    Nature: "Experimentation",
  },
  {
    Roll: "20BEC502",
    Name: "Bhagyesh dantkodiya",
    Mail: "happysdantkodiya@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "Komoline Aerospace limited ",
    Linkedin: "https://in.linkedin.com/in/happy-dantkodiya-7b79481a1",
    Project: "Growth of potato in India using machine learning algorithms ",
    Description:
      "In this project we make research paper on potato growth in India using machine learning algorithms and we find better accuracy after comparing using different machine learning algorithm",
    Tools: "Anaconda navigator, Google collab, Python",
    Nature: "Research",
  },
  {
    Roll: "20BEC503",
    Name: "Hansaliya prit sarjubhai",
    Mail: "hansaliyaprit1213@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Amisha Naik",
    Company: "Komoline Aerospace Limited",
    Linkedin: "https://www.linkedin.com/in/prithansaliya/",
    Project: "AWS (Automatic Weather Station)",
    Description:
      "An automatic weather station (AWS) is an automated version of the traditional weather station, either to save human labour or to enable measurements from remote areas. An AWS will typically consist of a weather-proof enclosure containing the data logger, rechargeable battery, telemetry (optional) and the meteorological sensors with an attached solar panel or wind turbine and mounted upon a mast.",
    Tools: "Python, Embedded C, STM cube ",
    Nature: "Research",
  },
  {
    Roll: "20BEC504",
    Name: "Mansuri ayan",
    Mail: "ayan762000@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "eInfochips",
    Linkedin: "https://www.linkedin.com/in/ayan-mansuri-088899221/",
    Project: "HARDWARE",
    Description: "RF calibration and testing ",
    Tools: "vna machine ",
    Nature: "Product Developement",
  },
  {
    Roll: "20BEC505",
    Name: "Nisarg vyas",
    Mail: "nisargdvyas@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dhaval Shah",
    Company: "elnfochips Private Limited",
    Linkedin: "https://www.linkedin.com/in/nisarg-vyas-1369a0237/",
    Project: "Daughter Board for Camera Module.",
    Description:
      "Required to design a daughter board that will help connect the motherboard to the camera module.",
    Tools: "Device Designing",
    Nature: "Product Developement",
  },
  {
    Roll: "20BEC506",
    Name: "Dhyey piyush padia",
    Mail: "dhyey.padia1242@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Vaishali Dhare",
    Company: "Hitech Industries",
    Linkedin: "http://linkedin.com/in/dhyey-padia-6389b7241",
    Project: null,
    Description: null,
    Tools: null,
    Nature: "Product Developement",
  },
  {
    Roll: "20BEC511",
    Name: "Heet ankur shah",
    Mail: "heets42@gmail.com",
    Report: "File Uploaded",
    Guide: "Dr Dilip Kothari",
    Company: "SAC ISRO",
    Linkedin: "www.linkedin.com/in/heet-shah4",
    Project: "Deployment of ML models on Edge Devices",
    Description:
      "Developing a ML model for one of the ongoing projects and deploy the optimized models on edge devices like Xilinx ZCU104 or Xilinx KV260",
    Tools: "Xilinx Vitis, Xilinx Vivado, Xilinx ZCU104, KV260, Python, Linux",
    Nature: "Research",
  },
];

export default mpdata2023;